"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var swipeable_1 = require("../swipeable");
var _1 = require("../util/_");
var vdl_prefix_1 = require("../util/vdl-prefix");
var ToggleSwitch = /** @class */ (function (_super) {
    __extends(ToggleSwitch, _super);
    function ToggleSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            checked: (typeof _this.props.checked !== 'undefined'
                ? _this.props.checked
                : _this.props.defaultChecked)
        };
        _this.isChecked = function () {
            return (typeof _this.props.checked !== 'undefined' ? _this.props.checked : _this.state.checked);
        };
        _this.handleSwipe = function (newValue) {
            if (_this.isChecked() !== newValue) {
                ReactDOM.findDOMNode(_this.refs['label']).click();
            }
        };
        _this.handleRightSwipe = function () {
            _this.handleSwipe(true);
        };
        _this.handleLeftSwipe = function () {
            _this.handleSwipe(false);
        };
        _this.handleChange = function (e) {
            var value = e.target.checked;
            if (_this.props.disabled) {
                return;
            }
            if (typeof _this.props.checked === 'undefined') {
                _this.setState({
                    checked: value
                }, function () {
                    if (typeof this.props.onChange === 'function') {
                        this.props.onChange(value);
                    }
                });
            }
            else {
                if (typeof _this.props.onChange === 'function') {
                    _this.props.onChange(value);
                }
            }
        };
        return _this;
    }
    ToggleSwitch.prototype.componentWillReceiveProps = function (nextProps) {
        if (typeof nextProps.checked !== 'undefined' && nextProps.checked !== this.state.checked) {
            this.setState({
                checked: nextProps.checked
            });
        }
    };
    ToggleSwitch.prototype.render = function () {
        var _a = this.props, className = _a.className, tabIndex = _a.tabIndex, children = _a.children, name = _a.name, disabled = _a.disabled, required = _a.required, checkedLabel = _a.checkedLabel, uncheckedLabel = _a.uncheckedLabel;
        var customProps = _1.omit(this.props, Object.keys(ToggleSwitch.propTypes));
        var checked = this.isChecked();
        var toggleSwitchClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('toggle-switch')] = true,
            _b[vdl_prefix_1.vdlPrefix('toggle-switch--checked')] = checked,
            _b[vdl_prefix_1.vdlPrefix('toggle-switch--disabled')] = disabled,
            _b[vdl_prefix_1.vdlPrefix('toggle-switch--required')] = required,
            _b);
        return (React.createElement(swipeable_1.Swipeable, { onSwipedRight: this.handleRightSwipe, onSwipedLeft: this.handleLeftSwipe },
            React.createElement("label", __assign({}, customProps, { className: classnames_1.classNames(className, toggleSwitchClasses) }),
                React.createElement("input", { type: "checkbox", tabIndex: disabled ? -1 : tabIndex || 0, onChange: this.handleChange, checked: checked, name: name, "aria-disabled": disabled, disabled: disabled }),
                React.createElement("div", { className: vdl_prefix_1.vdlPrefix('toggle-switch__container') },
                    React.createElement("div", { className: vdl_prefix_1.vdlPrefix('toggle-switch__toggle') },
                        React.createElement("div", { className: vdl_prefix_1.vdlPrefix('toggle-switch__slide') },
                            React.createElement("div", { className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('toggle-switch__label'), vdl_prefix_1.vdlPrefix('toggle-switch__label--checked')) }, checkedLabel),
                            React.createElement("div", { className: classnames_1.classNames(vdl_prefix_1.vdlPrefix('toggle-switch__label'), vdl_prefix_1.vdlPrefix('toggle-switch__label--unchecked')) }, uncheckedLabel),
                            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('toggle-switch__knob') }))),
                    React.createElement("span", null, children)))));
        var _b;
    };
    ToggleSwitch.propTypes = {
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        onChange: PropTypes.func,
        checked: PropTypes.bool,
        defaultChecked: PropTypes.bool,
        checkedLabel: PropTypes.node,
        uncheckedLabel: PropTypes.node,
        name: PropTypes.string,
        className: PropTypes.string,
        tabIndex: PropTypes.number,
        children: PropTypes.node,
    };
    ToggleSwitch.defaultProps = {
        disabled: false,
        required: false,
        defaultChecked: false
    };
    return ToggleSwitch;
}(React.PureComponent));
exports.ToggleSwitch = ToggleSwitch;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/toggle-switch/toggle-switch.js
// module id = 582
// module chunks = 0 1 2 3 4 5 6